import React, { useContext } from 'react'

import { isEmpty } from 'utils/browserHelper'
import { formatCurrency, getConversionRate, getCurrencyByLocale } from 'utils/currencyHelper'
import { CurrencyContext } from 'context/flights/results'
import { ItineraryDataContext } from 'context/itinerary'

const FormatCurrency = props => {
    const { price, currency, currencyContext, spaceBetween } = props
    let [currencies] = useContext(CurrencyContext)
    if (!isEmpty(currencyContext)) {
        currencies = currencyContext
    }
    const { conversionData = [], curCode = '' } = currencies || {}
    const toCurrency = currency || curCode
    const { currency: fromCurrency } = getCurrencyByLocale()

    const { rate: sellingRate } =
        toCurrency === fromCurrency
            ? { rate: 1 }
            : conversionData?.find(currencyObj => {
                  const { from, to } = currencyObj || {}
                  return from === fromCurrency && to === toCurrency
              }) || { rate: 1 }

    return <>{formatCurrency({ price, rate: 1, currencyCode: toCurrency, sellingRate, countUp: '', spaceBetween })}</>
}

export default FormatCurrency
